import { Component, inject } from '@angular/core';
import { PunchoutAuditCartTransferListConfigService } from '../../../../services/punchout-audit-cart-transfer-list-config.service';
import { PunchoutAuditTabBase } from '../punchout-audit-tab.base';

/**
 * Cart transfers tab: the PunchOutOrderMessage handed back to the procurement platform at
 * checkout, one row per transfer.
 */
@Component({
  selector: 'lib-gung-settings-punchout-cart-transfers',
  templateUrl: './gung-settings-punchout-cart-transfers.component.html',
  styleUrl: './gung-settings-punchout-cart-transfers.component.scss',
  standalone: false
})
export class GungSettingsPunchoutCartTransfersComponent extends PunchoutAuditTabBase {
  public readonly config = inject(PunchoutAuditCartTransferListConfigService);
}
